/**
 * This will scroll down when user selects language
 * @example ng-pills-scroll
 */

const ngPillsScroll = [() => {
    return {
        link: function ($scope, $element, $params) {

            $element[0].style.cursor = 'grab';

            let pos = { top: 0, left: 0, x: 0, y: 0 };

            const mouseDownHandler = function (e) {
                $element[0].style.cursor = 'grabbing';
                $element[0].style.userSelect = 'none';

                pos = {
                    left: $element[0].scrollLeft,
                    top: $element[0].scrollTop,
                    // Get the current mouse position
                    x: e.clientX,
                    y: e.clientY,
                };

                document.addEventListener('mousemove', mouseMoveHandler);
                document.addEventListener('mouseup', mouseUpHandler);
            };

            const mouseMoveHandler = function (e) {
                // How far the mouse has been moved
                const dx = e.clientX - pos.x;
                const dy = e.clientY - pos.y;

                // Scroll the element
                $element[0].scrollTop = pos.top - dy;
                $element[0].scrollLeft = pos.left - dx;
            };

            const mouseUpHandler = function () {
                $element[0].style.cursor = 'grab';
                $element[0].style.removeProperty('user-select');

                document.removeEventListener('mousemove', mouseMoveHandler);
                document.removeEventListener('mouseup', mouseUpHandler);

                $scope.pills.prevStatus = $element[0].scrollLeft > 0;
                $scope.$apply();

            };

            // Attach the handler
            $element[0].addEventListener('mousedown', mouseDownHandler);
        }
    }
}];

export default ngPillsScroll;

